var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1775527459114,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16426,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.85 469.55c-0.17 0-0.33-0.01-0.5-0.01 0.17 0 0.34 0.01 0.5 0.01z",
    fill: "#ADF7B9",
    "p-id": 16427
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M986.29 318.46l-0.03 0.01c-21.69-51.19-72.39-87.1-131.49-87.1-78.83 0-142.74 63.91-142.74 142.74 0 14.89 2.29 29.24 6.52 42.74l-0.12 0.04c15.17 45 23.39 93.19 23.39 143.31 0 223-162.78 407.95-375.99 442.59 46.24 13.72 95.2 21.12 145.9 21.12 282.92 0 512.27-229.35 512.27-512.27 0-68.36-13.42-133.57-37.71-193.18z",
    fill: "#00CC71",
    "p-id": 16428
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M724.86 113.5c71.39 0.11 135.9 29.47 182.24 76.72 1.4 1.43 2.89 2.76 4.48 3.96l5.22 3.93C822.77 77.23 675.78-0.41 510.65 0.1 227.94 0.98 0 229.67 0 512.37 0 619.4 32.84 718.75 88.97 800.93l0.39-0.26c46.22 63.62 121.02 105.14 205.56 105.64 139.96 0.83 255.58-112.53 257.37-252.49 0.65-51.1-13.69-98.79-38.89-139l0.41-0.28c-28.99-41.98-45.78-93.04-45.18-148.06 1.52-139.68 116.54-253.2 256.23-252.98z",
    fill: "#00CC71",
    "p-id": 16429
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M738.05 618.48c-42.88 144.1-172.04 251.03-327.59 260.83-34.83 17.48-74.12 27.24-115.54 26.99-84.54-0.5-159.34-42.02-205.56-105.64l-0.03 0.02c65.6 95.81 162.91 168.2 276.8 202.05 194.18-31.68 346.45-188.06 371.92-384.25z",
    fill: "#ADF7B9",
    "p-id": 16430
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.18 469.65c-0.71 0-1.42-0.01-2.12-0.02 0.71 0.01 1.42 0.01 2.12 0.02z",
    fill: "#ADF7B9",
    "p-id": 16431
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYb);
export default __webpack_public_path__ + "static/media/yb.1f5ec06d0e5d69ef030c3a764c414e2a.svg";
export { ForwardRef as ReactComponent };